import { useState, useEffect, useContext, useRef } from 'react';
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import {
  createIncomingOperationKey,
  deleteIncomingEntryApi,
  setIncomingPaymentStatusApi,
} from '../../lib/incomingApi';
import { EntradasContext } from '../../context/EntradasContext';
import IncomingForm from './IncomingForm.jsx'; // <- usa el JSX directamente
import IncomingBatchImport from './IncomingBatchImport.jsx';
import { useMemo } from 'react';
import { useProducts } from '../../context/ProductsContext';


const IncomingView = ({ onBack, currentUser, products, setProducts }) => {
const { loadAllProductsOnce, loadingAll } = useProducts();
const { entradas, loadingEntradas, cargarEntradas, paginaActual, hasMoreEntradas } = useContext(EntradasContext);

// Filtros
const [filtroFactura, setFiltroFactura] = useState('');
const [filtroProveedor, setFiltroProveedor] = useState('');
const [filtroTipo, setFiltroTipo] = useState('');
const [filtroFecha, setFiltroFecha] = useState('');
const [filtroEstado, setFiltroEstado] = useState(''); // '', 'pagado', 'pendiente'

const filtrosActuales = () => ({
  fecha: filtroFecha,
  proveedor: filtroProveedor,
  tipo: filtroTipo,
  estado: filtroEstado,
});
const cargarPagina = (n, opts = {}) => cargarEntradas(n, filtrosActuales(), opts);

  const [incomingItems, setIncomingItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingEntry, setEditingEntry] = useState(null); // Para edici?n
  const [selectedEntry, setSelectedEntry] = useState(null);
const [showDetailModal, setShowDetailModal] = useState(false);
const [detailLoading, setDetailLoading] = useState(false);
const [imagenModal, setImagenModal] = useState(null); // ?? Nuevo estado
const [showBatchImport, setShowBatchImport] = useState(false);
const deleteOperationKeysRef = useRef(new Map());
const paymentOperationKeysRef = useRef(new Map());

const openBatchImport = async () => {
  await loadAllProductsOnce({ force: true });
  setShowBatchImport(true);
};

useEffect(() => {
  setIncomingItems((entradas || []).map((e) => normalizeEntry(e)));
}, [entradas]);

  // Nuevos filtros

// Opciones din?micas a partir de los datos ya cargados
const proveedoresOptions = useMemo(() => {
  const set = new Set((incomingItems || []).map(x => x?.supplier).filter(Boolean));
  return Array.from(set).sort((a,b) => a.localeCompare(b));
}, [incomingItems]);

const tiposOptions = useMemo(() => {
  const set = new Set((incomingItems || []).map(x => x?.entryType).filter(Boolean));
  return Array.from(set).sort((a,b) => a.localeCompare(b));
}, [incomingItems]);

const getItemDateStr = (item) => {
  // Usa registrationDate si existe, de lo contrario intenta derivar de date/timestamp
  if (item?.registrationDate) return String(item.registrationDate);
  if (item?.date) {
    const s = String(item.date);
    return s.includes('T') ? s.slice(0, 10) : s;
  }
  if (item?.timestamp?.toDate) {
    const d = item.timestamp.toDate();
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  }
  return '';
};

// Limpiar filtros
const limpiarFiltros = () => {
  setFiltroFactura('');
  setFiltroProveedor('');
  setFiltroTipo('');
  setFiltroFecha('');
  setFiltroEstado('');
  cargarEntradas(1, {}, { force: true });
};

const aplicarFiltros = () => {
  cargarEntradas(1, filtrosActuales(), { force: true });
};

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

const normalizeNumber = (value) => {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const cleaned = String(value)
    .replace(/[^\d,.-]/g, '')
    .replace(/\./g, '')
    .replace(/,/g, '.');
  const num = Number(cleaned);
  return Number.isFinite(num) ? num : 0;
};

const normalizeEntry = (entry = {}) => {
  const products = Array.isArray(entry.products)
    ? entry.products.map((p) => ({
        ...p,
        quantity: normalizeNumber(p.quantity),
        unitCost: normalizeNumber(p.unitCost),
        totalCost: normalizeNumber(p.totalCost),
      }))
    : [];

  const totalFromProducts = products.reduce(
    (sum, p) => sum + normalizeNumber(p.totalCost),
    0
  );
  const rawTotal = normalizeNumber(entry.totalEntryCost);
  const safeTotal = rawTotal > 0 ? rawTotal : totalFromProducts;

  return {
    ...entry,
    products,
    totalEntryCost: safeTotal,
  };
};

const applyProductUpdates = (updates = []) => {
  if (typeof setProducts !== 'function' || !Array.isArray(updates) || updates.length === 0) return;
  setProducts(previous => {
    const byId = new Map(updates.map(item => [item.id, item]));
    return previous.map(product => {
      const update = byId.get(product.id);
      if (!update) return product;
      const { created, ...safeUpdate } = update;
      return { ...product, ...safeUpdate };
    });
  });
};

const [confirmDelete, setConfirmDelete] = useState({ open: false, entry: null, loading: false });

const handleDeleteEntry = async (idEntrada, _productosEntrada = [], { skipConfirm = false } = {}) => {
  if (!skipConfirm) {
    const confirm = window.confirm("¿Estás seguro de que quieres eliminar esta entrada completa?");
    if (!confirm) return false;
  }

  const keys = deleteOperationKeysRef.current;
  const idempotencyKey = keys.get(idEntrada) || createIncomingOperationKey();
  keys.set(idEntrada, idempotencyKey);

  try {
    const result = await deleteIncomingEntryApi({ entryId: idEntrada, idempotencyKey });
    keys.delete(idEntrada);
    applyProductUpdates(result?.productUpdates || []);
    setIncomingItems((prev) => prev.filter((e) => e.id !== idEntrada));
    return true;
  } catch (error) {
    console.error("Error al eliminar entrada:", error);
    alert(error?.message || "Ocurrió un error al eliminar la entrada.");
    return false;
  }
};

const isProtectedSaleReturnEntry = (entry) => (
  !!entry?.sourceSaleId
  || !!entry?.returnId
  || String(entry?.entryType || '').toLowerCase() === 'devolucion'
);

const openDeleteModal = (entry) => {
  if (isProtectedSaleReturnEntry(entry)) {
    alert('Esta entrada proviene de una devolución de venta. Debe corregirse desde el módulo de ventas para conservar la trazabilidad.');
    return;
  }
  setConfirmDelete({ open: true, entry, loading: false });
};

const closeDeleteModal = () => {
  if (confirmDelete.loading) return;
  setConfirmDelete({ open: false, entry: null, loading: false });
};

const confirmDeleteEntry = async () => {
  if (!confirmDelete.entry?.id) return;
  setConfirmDelete((prev) => ({ ...prev, loading: true }));
  const deleted = await handleDeleteEntry(confirmDelete.entry.id, confirmDelete.entry.products || [], { skipConfirm: true });
  if (deleted) setConfirmDelete({ open: false, entry: null, loading: false });
  else setConfirmDelete((prev) => ({ ...prev, loading: false }));
};

const handleEditEntry = (entry) => {
  if (isProtectedSaleReturnEntry(entry)) {
    alert('Esta entrada proviene de una devolución de venta. Debe corregirse desde el módulo de ventas para conservar la trazabilidad.');
    return;
  }
  setEditingEntry(entry);
  setShowForm(true);
};

// ✅ DEJA solo esta definición:

const handleTogglePaymentStatus = async (id) => {
  const entrada = incomingItems.find(item => item.id === id);
  if (!entrada) return;
  if (isProtectedSaleReturnEntry(entrada)) {
    alert('Esta entrada proviene de una devolución de venta y no debe modificarse manualmente.');
    return;
  }

  const nuevoEstado = (entrada.paymentStatus || '').toLowerCase() === 'pagado'
    ? 'pendiente'
    : 'pagado';
  const keys = paymentOperationKeysRef.current;
  const idempotencyKey = keys.get(id) || createIncomingOperationKey();
  keys.set(id, idempotencyKey);

  try {
    const result = await setIncomingPaymentStatusApi({
      entryId: id,
      paymentStatus: nuevoEstado,
      idempotencyKey,
    });
    keys.delete(id);

    setIncomingItems(prev =>
      prev.map(item =>
        item.id === id
          ? {
              ...item,
              paymentStatus: result?.paymentStatus || nuevoEstado,
              affectsCash: result?.affectsCash === true,
              turnId: result?.turnId || null,
            }
          : item
      )
    );
  } catch (error) {
    console.error("Error al actualizar estado de pago:", error);
    alert(error?.message || "No se pudo actualizar el estado de pago.");
  }
};

const handleOpenDetails = async (entry) => {
  const fallback = normalizeEntry(entry);
  setSelectedEntry(fallback);
  setShowDetailModal(true);
  setDetailLoading(true);

  try {
    const snap = await getDoc(doc(db, 'entradas', entry.id));
    if (snap.exists()) {
      const fresh = normalizeEntry({ id: entry.id, ...snap.data() });
      setSelectedEntry(fresh);
    }
  } catch (err) {
    console.warn('No se pudo recargar detalle de entrada', err);
  } finally {
    setDetailLoading(false);
  }
};
const itemsFiltrados = incomingItems.filter((item) => {
  const coincideFactura   = (item.invoiceNumber || '').toLowerCase().includes(filtroFactura.toLowerCase());
const coincideProveedor = filtroProveedor
  ? (item.supplier || '') === filtroProveedor
 : true;
const coincideTipo = filtroTipo
 ? (item.entryType || '').toLowerCase() === filtroTipo.toLowerCase()
 : true;  const coincideFecha     = filtroFecha ? getItemDateStr(item) === filtroFecha : true;
const coincideEstado    = filtroEstado ? (item.paymentStatus || '').toLowerCase() === filtroEstado.toLowerCase() : true;

  return coincideFactura && coincideProveedor && coincideTipo && coincideFecha && coincideEstado;
});

const productMap = useMemo(() => {
  const map = new Map();
  (products || []).forEach((p) => {
    if (p?.id) map.set(p.id, p);
  });
  return map;
}, [products]);

const selectedProducts = selectedEntry?.products || [];
const enrichedProducts = selectedProducts.map((p) => {
  const catalog = p.productId ? productMap.get(p.productId) : null;
  const catalogType = String(catalog?.type || '').toLowerCase();
  const isInsumo = catalogType === 'insumo';
  const quantity = normalizeNumber(p.quantity);
  const unitCost = normalizeNumber(p.unitCost);
  const totalCost = normalizeNumber(p.totalCost);
  const rawSale = normalizeNumber(catalog?.price);
  const hasSalePrice = !isInsumo && rawSale > 0;
  const salePrice = hasSalePrice ? rawSale : 0;
  const totalSale = salePrice * quantity;
  const unitProfit = hasSalePrice ? (salePrice - unitCost) : 0;
  const totalProfit = hasSalePrice ? (unitProfit * quantity) : 0;
  return {
    ...p,
    quantity,
    unitCost,
    totalCost,
    salePrice,
    totalSale,
    unitProfit,
    totalProfit,
  };
});

const detailTotal = enrichedProducts.reduce((sum, p) => sum + normalizeNumber(p.totalCost), 0);
const detailTotalSale = enrichedProducts.reduce((sum, p) => sum + (p.salePrice > 0 ? normalizeNumber(p.totalSale) : 0), 0);
const detailTotalProfit = enrichedProducts.reduce((sum, p) => sum + (p.salePrice > 0 ? normalizeNumber(p.totalProfit) : 0), 0);
const activeFilters = [
  filtroFactura && `Factura: ${filtroFactura}`,
  filtroProveedor && `Proveedor: ${filtroProveedor}`,
  filtroTipo && `Tipo: ${filtroTipo}`,
  filtroFecha && `Fecha: ${filtroFecha}`,
  filtroEstado && `Estado: ${filtroEstado}`,
].filter(Boolean);

const getRegisteredByLabel = (entry) => (
  typeof entry?.registeredBy === 'string'
    ? entry.registeredBy
    : (
      entry?.registeredBy?.username ||
      entry?.registeredBy?.email ||
      entry?.registeredBy?.uid ||
      '-'
    )
);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50 p-3 sm:p-6">
      <div className="mb-6 rounded-[28px] border border-slate-200 bg-white/95 p-4 shadow-sm sm:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <button
          onClick={onBack}
          className="flex items-center justify-center gap-2 rounded-2xl border border-emerald-200 px-4 py-3 text-sm font-semibold text-emerald-700 transition hover:border-emerald-400 hover:text-emerald-900 sm:w-fit"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Volver al Menú
        </button>
        <div className="flex-1 text-center lg:text-left">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-emerald-700">Inventario</p>
          <h1 className="mt-1 text-2xl font-black text-slate-900 sm:text-4xl">Registro de Entradas</h1>
          <p className="mt-2 text-sm text-slate-500">
            {itemsFiltrados.length} registro{itemsFiltrados.length === 1 ? '' : 's'} visible{itemsFiltrados.length === 1 ? '' : 's'}
          </p>
        </div>
        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
          <button
            onClick={openBatchImport}
            disabled={loadingAll}
            className="flex w-full items-center justify-center gap-2 rounded-2xl border border-emerald-300 bg-emerald-50 px-4 py-3 text-sm font-semibold text-emerald-800 shadow-sm transition hover:border-emerald-500 hover:bg-emerald-100 sm:w-auto"
          >
            {loadingAll ? 'Cargando catalogo...' : 'Importar lote'}
          </button>
          <button
            onClick={() => { setShowForm(true); setEditingEntry(null); }}
            className="flex w-full items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-700 sm:w-auto"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Nueva entrada
          </button>
        </div>
        </div>
      </div>

{/* Subtítulo con el conteo de resultados */}
{showForm ? (
  <IncomingForm
    currentUser={currentUser}
    products={products}
    editingEntry={editingEntry}
    setEditingEntry={setEditingEntry}
    setShowForm={setShowForm}
    setIncomingItems={setIncomingItems}
    setProducts={setProducts}
  />
) : (
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
{/* 🔎 Filtros modernos “sticky” */}
<div className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 px-4">
  <div className="flex flex-col lg:flex-row lg:items-end gap-3 py-4">

    {/* Nº Factura */}
    <div className="flex-1">
      <label className="block text-xs font-semibold text-gray-600 mb-1">N° Factura</label>
      <div className="relative">
        <span className="absolute left-3 top-2.5 pointer-events-none">🔍</span>
        <input
          type="text"
          placeholder="Buscar factura..."
          value={filtroFactura}
          onChange={(e) => setFiltroFactura(e.target.value)}
          className="w-full pl-9 pr-3 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition shadow-sm"
        />
        {filtroFactura && (
          <button
            onClick={() => setFiltroFactura('')}
            className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
            title="Limpiar"
          >✕</button>
        )}
      </div>
    </div>

    {/* Proveedor (select) */}
    <div className="flex-1 min-w-[220px]">
      <label className="block text-xs font-semibold text-gray-600 mb-1">Proveedor</label>
      <div className="relative">
        <select
          value={filtroProveedor}
          onChange={(e) => setFiltroProveedor(e.target.value)}
          className="w-full appearance-none pl-3 pr-9 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition shadow-sm bg-white"
        >
          <option value="">Todos</option>
          {proveedoresOptions.map(p => (
            <option key={p} value={p}>{p}</option>
          ))}
        </select>
        <span className="absolute right-3 top-2.5 text-gray-400">▾</span>
      </div>
    </div>

    {/* Tipo (select) */}
    <div className="flex-1 min-w-[220px]">
      <label className="block text-xs font-semibold text-gray-600 mb-1">Tipo</label>
      <div className="relative">
        <select
          value={filtroTipo}
          onChange={(e) => setFiltroTipo(e.target.value)}
          className="w-full appearance-none pl-3 pr-9 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition shadow-sm bg-white"
        >
          <option value="">Todos</option>
          {tiposOptions.map(t => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
        <span className="absolute right-3 top-2.5 text-gray-400">▾</span>
      </div>
    </div>

    {/* Fecha */}
    <div>
      <label className="block text-xs font-semibold text-gray-600 mb-1">Fecha</label>
      <input
        type="date"
        value={filtroFecha}
        onChange={(e) => setFiltroFecha(e.target.value)}
        className="pl-3 pr-3 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition shadow-sm bg-white"
      />
    </div>

    {/* Estado de pago (chips) */}
    <div className="min-w-[220px]">
      <label className="block text-xs font-semibold text-gray-600 mb-1">Estado de pago</label>
      <div className="flex gap-2">
        <button
          onClick={() => setFiltroEstado('')}
          className={`px-3 py-1.5 rounded-full border text-sm transition ${
            !filtroEstado ? 'bg-emerald-600 text-white border-emerald-600 shadow' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
          }`}
        >
          Todos
        </button>
        <button
          onClick={() => setFiltroEstado('pagado')}
          className={`px-3 py-1.5 rounded-full border text-sm transition ${
            filtroEstado === 'pagado' ? 'bg-emerald-600 text-white border-emerald-600 shadow' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
          }`}
        >
          Pagado
        </button>
        <button
          onClick={() => setFiltroEstado('pendiente')}
          className={`px-3 py-1.5 rounded-full border text-sm transition ${
            filtroEstado === 'pendiente' ? 'bg-amber-500 text-white border-amber-500 shadow' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
          }`}
        >
          Pendiente
        </button>
      </div>
    </div>

    {/* Acciones */}
    <div className="flex items-end gap-2 ml-auto">
      <div className="text-sm text-gray-600 hidden lg:block">
        {itemsFiltrados.length} resultado{itemsFiltrados.length === 1 ? '' : 's'}
      </div>
      <button
        onClick={aplicarFiltros}
        className="px-4 py-2 rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 transition shadow-sm"
      >
        Aplicar / Buscar
      </button>
      <button
        onClick={() => cargarEntradas(1, filtrosActuales(), { force: true })}
        className="px-4 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 transition shadow-sm"
      >
        Actualizar
      </button>
      <button
        onClick={limpiarFiltros}
        disabled={!(filtroFactura || filtroProveedor || filtroTipo || filtroFecha || filtroEstado)}
        className={`px-4 py-2 rounded-xl border transition shadow-sm ${
          (filtroFactura || filtroProveedor || filtroTipo || filtroFecha || filtroEstado)
    ? 'border-gray-300 text-gray-700 hover:bg-gray-50'
    : 'border-gray-200 text-gray-400 cursor-not-allowed bg-gray-50'
 }`}
      >
        Limpiar
      </button>
    </div>

  </div>
</div>

{/* Píldoras con filtros activos */}
{(filtroFactura || filtroProveedor || filtroTipo || filtroFecha || filtroEstado) && (
  <div className="px-4 py-2 bg-white border-b border-gray-200 flex flex-wrap gap-2">
    {filtroFactura && (
      <span className="px-2 py-1 rounded-full text-xs bg-gray-100">
        Factura: <b>{filtroFactura}</b>
      </span>
    )}
    {filtroProveedor && (
      <span className="px-2 py-1 rounded-full text-xs bg-gray-100">
        Proveedor: <b>{filtroProveedor}</b>
      </span>
    )}
    {filtroTipo && (
      <span className="px-2 py-1 rounded-full text-xs bg-gray-100">
        Tipo: <b>{filtroTipo}</b>
      </span>
    )}
    {filtroFecha && (
      <span className="px-2 py-1 rounded-full text-xs bg-gray-100">
        Fecha: <b>{filtroFecha}</b>
      </span>
    )}
    {filtroEstado && (
      <span className="px-2 py-1 rounded-full text-xs bg-gray-100">
        Estado: <b>{filtroEstado}</b>
      </span>
    )}
  </div>
)}

            <div className="p-4 sm:hidden">
              {loadingEntradas ? (
                <div className="rounded-2xl border border-dashed border-emerald-200 bg-emerald-50 px-4 py-8 text-center text-sm font-semibold text-emerald-700">
                  Cargando entradas...
                </div>
              ) : itemsFiltrados.length > 0 ? (
                <div className="space-y-3">
                  {itemsFiltrados.map((item) => (
                    <article key={item.id} className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
                      <div className="flex items-start justify-between gap-3">
                        <div>
                          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">{getItemDateStr(item) || 'Sin fecha'}</p>
                          <h3 className="mt-1 text-base font-bold text-slate-900">{item.invoiceNumber || 'Sin factura'}</h3>
                          <p className="mt-1 text-sm text-slate-500">{item.supplier || 'Sin proveedor'}</p>
                        </div>
                        <div className="text-right">
                          <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${String(item.entryType || '').toLowerCase() === 'compra' ? 'bg-emerald-100 text-emerald-800' : (String(item.entryType || '').toLowerCase() === 'ajuste' ? 'bg-blue-100 text-blue-800' : 'bg-slate-100 text-slate-700')}`}>
                            {item.entryType || 'N/D'}
                          </span>
                          <span className={`mt-2 inline-flex rounded-full px-3 py-1 text-xs font-semibold ${item.paymentStatus === 'pagado' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`}>
                            {item.paymentStatus || 'pendiente'}
                          </span>
                        </div>
                      </div>

                      <div className="mt-4 grid grid-cols-2 gap-3 rounded-2xl bg-slate-50 p-3 text-sm">
                        <div>
                          <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Total</p>
                          <p className="mt-1 font-semibold text-slate-900">{formatCurrency(item.totalEntryCost)}</p>
                        </div>
                        <div>
                          <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Usuario</p>
                          <p className="mt-1 font-semibold text-slate-900">{getRegisteredByLabel(item)}</p>
                        </div>
                      </div>

                      <div className="mt-4 grid grid-cols-2 gap-2">
                        <button onClick={() => handleOpenDetails(item)} className="rounded-2xl border border-indigo-200 px-3 py-2 text-sm font-semibold text-indigo-700 transition hover:bg-indigo-50">Detalle</button>
                        <button onClick={() => handleEditEntry(item)} className="rounded-2xl border border-sky-200 px-3 py-2 text-sm font-semibold text-sky-700 transition hover:bg-sky-50">Editar</button>
                        <button onClick={() => openDeleteModal(item)} className="rounded-2xl border border-rose-200 px-3 py-2 text-sm font-semibold text-rose-700 transition hover:bg-rose-50">Eliminar</button>
                        <button
                          onClick={() => handleTogglePaymentStatus(item.id)}
                          className={`rounded-2xl px-3 py-2 text-sm font-semibold text-white transition ${item.paymentStatus === 'pagado' ? 'bg-amber-500 hover:bg-amber-600' : 'bg-emerald-600 hover:bg-emerald-700'}`}
                        >
                          {item.paymentStatus === 'pagado' ? 'Pendiente' : 'Pagado'}
                        </button>
                      </div>
                    </article>
                  ))}
                </div>
              ) : (
                <div className="rounded-2xl border border-dashed border-slate-200 px-4 py-8 text-center text-sm text-slate-500">
                  No hay entradas registradas.
                </div>
              )}
            </div>

            <table className="hidden min-w-full divide-y divide-gray-200 sm:table">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">N° Factura</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Proveedor</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado Pago</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Entrada</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuario</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
{loadingEntradas ? (
  <tr>
    <td colSpan="8" className="text-center py-6 text-blue-500 font-semibold">Cargando entradas...</td>
  </tr>
) : incomingItems.length > 0 ? (
itemsFiltrados.map((item) => (
                    <tr key={item.id} className="odd:bg-white even:bg-gray-50 hover:bg-gray-50 transition duration-150">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{getItemDateStr(item)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.invoiceNumber}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.supplier}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">
                        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                          String(item.entryType || '').toLowerCase() === 'compra'
                            ? 'bg-emerald-100 text-emerald-800'
                            : (String(item.entryType || '').toLowerCase() === 'ajuste'
                                ? 'bg-blue-100 text-blue-800'
                                : 'bg-gray-100 text-gray-700')
                        }`}>{item.entryType}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
 item.paymentStatus === 'pagado' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                         }`}>
                          {item.paymentStatus}
                        </span>
                      </td>
<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-semibold">
  {formatCurrency(item.totalEntryCost)}
</td>
<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
  {typeof item.registeredBy === 'string'
  ? item.registeredBy
   : (item.registeredBy?.username ||
     item.registeredBy?.email ||
      item.registeredBy?.uid ||
      '—')}
 </td>      
                 <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <button
                        onClick={() => handleOpenDetails(item)}
                        className="text-indigo-600 hover:text-indigo-800 transition duration-150 mr-3"
                      >
                        Ver Detalle
                      </button>

                        <button
                          onClick={() => handleEditEntry(item)}
                          className="text-blue-600 hover:text-blue-800 transition duration-150 mr-3"
                          
                        >
                          Editar
                        </button>
<button
  onClick={() => openDeleteModal(item)}
  className="text-red-600 hover:text-red-800 transition duration-150 mr-3"
>
  Eliminar
</button>
                        <button
                          onClick={() => handleTogglePaymentStatus(item.id)}
className={`text-sm px-2 py-1 rounded ${item.paymentStatus === 'pagado' ? 'bg-yellow-500 text-white' : 'bg-green-500 text-white'} hover:opacity-80 transition duration-150`}                        >
{item.paymentStatus === 'pagado' ? 'Marcar Pendiente' : 'Marcar Pagado'}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="px-6 py-4 text-center text-sm text-gray-500">
                      No hay entradas registradas.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="my-6 flex flex-col items-center justify-center gap-3 px-4 sm:flex-row sm:gap-4">
  <button
    onClick={() => cargarPagina(paginaActual - 1)}
    disabled={(paginaActual === 1) || loadingEntradas}
    className="w-full rounded-2xl bg-gray-300 px-4 py-3 text-gray-700 hover:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto"
  >
    Pagina anterior
  </button>
  <span className="font-medium text-gray-600">Pagina {paginaActual}</span>
  <button
    onClick={() => cargarPagina(paginaActual + 1)}
    disabled={!hasMoreEntradas || loadingEntradas}
    className="w-full rounded-2xl bg-gray-300 px-4 py-3 text-gray-700 hover:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto"
    title={!hasMoreEntradas ? "No hay m?s entradas" : ""}
  >
    Pagina siguiente
  </button>
</div>

          </div>
        </div>
      )}
{showDetailModal && selectedEntry && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-3 sm:px-6 backdrop-blur-sm">
    <div
      className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl overflow-hidden border border-gray-200"
      style={{ maxHeight: 'calc(100vh - 32px)' }}
    >
      <div className="flex items-start justify-between px-4 sm:px-6 pt-4 sm:pt-5 pb-3 border-b sticky top-0 bg-white z-10">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800">Detalle de Productos</h2>
          <p className="text-sm text-gray-500 mt-1">
            {selectedEntry?.invoiceNumber ? `Factura: ${selectedEntry.invoiceNumber} - ` : ''}
            Proveedor: {selectedEntry?.supplier || 'Sin proveedor'}
          </p>
        </div>
        <button
          onClick={() => { setShowDetailModal(false); setDetailLoading(false); }}
          className="text-gray-500 hover:text-red-500 transition text-sm sm:text-base"
        >
          Cerrar
        </button>
      </div>

      <div
        className="space-y-3 px-4 py-4 sm:px-6"
        style={{ maxHeight: 'calc(100vh - 220px)', overflowY: 'auto' }}
      >
        <div className="flex flex-wrap items-center justify-between gap-2 text-sm text-gray-600">
          <span>Productos: <span className="font-semibold text-gray-800">{selectedProducts.length}</span></span>
          <span className="font-semibold text-gray-800">Total: {formatCurrency(detailTotal)}</span>
        </div>

        {detailLoading ? (
          <div className="py-16 text-center text-gray-500">Cargando detalle...</div>
        ) : (
          <>
            <div className="space-y-3 sm:hidden">
              {enrichedProducts.map((p, idx) => (
                <article key={p.id || `${p.productId || 'row'}-${idx}`} className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
                  <h3 className="text-base font-bold text-slate-900">{p.productName}</h3>
                  <div className="mt-3 grid grid-cols-2 gap-3 rounded-2xl bg-slate-50 p-3 text-sm">
                    <div>
                      <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Cantidad</p>
                      <p className="mt-1 font-semibold text-slate-900">{p.quantity}</p>
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Costo</p>
                      <p className="mt-1 font-semibold text-slate-900">{formatCurrency(p.unitCost)}</p>
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Venta</p>
                      <p className="mt-1 font-semibold text-slate-900">{p.salePrice > 0 ? formatCurrency(p.salePrice) : '-'}</p>
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Utilidad</p>
                      <p className="mt-1 font-semibold text-slate-900">{p.salePrice > 0 ? formatCurrency(p.totalProfit) : '-'}</p>
                    </div>
                  </div>
                  <div className="mt-3 flex items-center justify-between text-sm">
                    <span className="text-slate-500">Total entrada</span>
                    <span className="font-bold text-slate-900">{formatCurrency(p.totalCost)}</span>
                  </div>
                </article>
              ))}
            </div>
            <div className="hidden overflow-x-auto rounded-xl border shadow-sm sm:block">
              <table className="min-w-full text-xs sm:text-sm text-gray-700">
                <thead className="bg-gray-100 uppercase text-gray-600 tracking-wider sticky top-0">
                  <tr>
                    <th className="px-3 sm:px-4 py-2 text-left">Producto</th>
                    <th className="px-3 sm:px-4 py-2 text-left">Cantidad</th>
                    <th className="px-3 sm:px-4 py-2 text-left">Costo Unitario</th>
                    <th className="px-3 sm:px-4 py-2 text-left">Precio Venta</th>
                    <th className="px-3 sm:px-4 py-2 text-left">Utilidad Unitaria</th>
                    <th className="px-3 sm:px-4 py-2 text-left">Utilidad Total</th>
                    <th className="px-3 sm:px-4 py-2 text-left">Precio Total de la entrada</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {enrichedProducts.map((p, idx) => (
                    <tr
                      key={p.id || `${p.productId || 'row'}-${idx}`}
                      className="hover:bg-gray-50 transition duration-150"
                    >
                      <td className="px-3 sm:px-4 py-2">{p.productName}</td>
                      <td className="px-3 sm:px-4 py-2">{p.quantity}</td>
                      <td className="px-3 sm:px-4 py-2">{formatCurrency(p.unitCost)}</td>
                      <td className="px-3 sm:px-4 py-2">{p.salePrice > 0 ? formatCurrency(p.salePrice) : '—'}</td>
                      <td className="px-3 sm:px-4 py-2">{p.salePrice > 0 ? formatCurrency(p.unitProfit) : '—'}</td>
                      <td className="px-3 sm:px-4 py-2">{p.salePrice > 0 ? formatCurrency(p.totalProfit) : '—'}</td>
                      <td className="px-3 sm:px-4 py-2 font-semibold">{formatCurrency(p.totalCost)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <div className="flex flex-col gap-3 border-t bg-white px-4 pb-5 pt-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div className="space-y-1 text-sm text-gray-600">
          <div>Total productos: {selectedProducts.length}</div>
          <div className="text-emerald-700 font-semibold">Utilidad potencial: {formatCurrency(detailTotalProfit)}</div>
        </div>
        <div className="text-right">
          <div className="text-xs text-gray-500">Total costo de la entrada</div>
          <div className="text-lg sm:text-xl font-bold text-gray-900">{formatCurrency(detailTotal)}</div>
        </div>
      </div>
    </div>
  </div>
)}
{imagenModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-xl shadow-2xl max-w-2xl w-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">📷 Comprobante</h2>
        <button
          onClick={() => setImagenModal(null)}
          className="text-gray-600 hover:text-red-500"
        >
          ✖
        </button>
      </div>
      <img src={imagenModal} alt="Comprobante" className="w-full max-h-[500px] object-contain border rounded" />
    </div>
  </div>
)}

{/* Modal de confirmación para eliminar entrada */}
{showBatchImport && (
  <IncomingBatchImport
    currentUser={currentUser}
    products={products}
    onClose={() => setShowBatchImport(false)}
    onImported={() => cargarEntradas(1, {}, { force: true })}
  />
)}

{confirmDelete.open && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 space-y-4">
      <div>
        <p className="text-lg font-semibold text-gray-900">Eliminar entrada</p>
        <p className="text-sm text-gray-600 mt-1">
          Esta acción revertirá el stock y eliminará el gasto ligado (si lo hay). ¿Deseas continuar?
        </p>
      </div>

      <div className="bg-gray-50 rounded-xl p-3 text-sm text-gray-700">
        <div className="flex justify-between">
          <span className="text-gray-500">Factura</span>
          <span className="font-semibold text-gray-900">{confirmDelete.entry?.invoiceNumber || '—'}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Proveedor</span>
          <span className="font-semibold text-gray-900">{confirmDelete.entry?.supplier || '—'}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Total entrada</span>
          <span className="font-semibold text-gray-900">{formatCurrency(confirmDelete.entry?.totalEntryCost || 0)}</span>
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <button
          onClick={closeDeleteModal}
          disabled={confirmDelete.loading}
          className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-60"
        >
          Cancelar
        </button>
        <button
          onClick={confirmDeleteEntry}
          disabled={confirmDelete.loading}
          className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
        >
          {confirmDelete.loading ? 'Eliminando...' : 'Eliminar'}
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default IncomingView;
